import { useSetAtom, WritableAtom } from 'jotai'
import { useEffect } from 'react'

export const useSyncAtom = <T>({
	value,
	atom,
}: {
	value: T
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	atom: WritableAtom<T, any, any>
}) => {
	const setAtom = useSetAtom(atom)

	useEffect(() => setAtom(value), [value, setAtom])
}
